const STORAGE_KEY = "bkcrawl.anthropicApiKey";

/** Persist an Anthropic API key to localStorage. */
export function saveApiKey(key: string): void {
  localStorage.setItem(STORAGE_KEY, key);
}

/** Retrieve the stored Anthropic API key, or null if none is saved. */
export function loadApiKey(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

/** Remove the stored API key and revert to the NullLLMClient. */
export function clearApiKey(): void {
  localStorage.removeItem(STORAGE_KEY);
}

/** True when an API key is currently stored. */
export function hasApiKey(): boolean {
  return localStorage.getItem(STORAGE_KEY) !== null;
}
